import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --maxWidth: 1320px;
    --gutter: clamp(16px, 4vw, 40px);

    --bg: #f4efe6;
    --surface: #fbf8f2;
    --surface-2: #ebe4d6;
    --ink: #17130f;
    --ink-2: #463f36;
    --muted: #857b6d;
    --line: #ddd4c4;
    --accent: #e0442a;
    --accent-dark: #b9321c;
    --gold: #d9a43a;
    --night: #120f0c;
    --night-2: #1e1914;
    --on-night: #f6f1e8;
    --on-night-muted: #b3a998;

    --radius-sm: 8px;
    --radius: 14px;
    --radius-lg: 28px;
    --shadow-sm: 0 1px 2px rgba(23, 19, 15, 0.06), 0 2px 8px rgba(23, 19, 15, 0.06);
    --shadow: 0 2px 4px rgba(23, 19, 15, 0.06), 0 12px 32px -8px rgba(23, 19, 15, 0.22);
    --shadow-lg: 0 30px 60px -20px rgba(23, 19, 15, 0.45);

    --font-display: 'Fraunces', 'Iowan Old Style', Georgia, serif;
    --font-body: 'DM Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;
    --font-mono: 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace;
    --ease: cubic-bezier(0.2, 0.7, 0.2, 1);
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    background: var(--bg);
    color: var(--ink);
    font-family: var(--font-body);
    font-size: 16px;
    line-height: 1.55;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  h1, h2, h3, h4 {
    font-family: var(--font-display);
    font-weight: 600;
    line-height: 1.05;
    letter-spacing: -0.02em;
    margin: 0;
  }

  p {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  img {
    display: block;
    max-width: 100%;
  }

  button, input {
    font: inherit;
    color: inherit;
  }

  ::selection {
    background: var(--accent);
    color: #fff;
  }

  :focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 3px;
    border-radius: 4px;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(14px); }
    to { opacity: 1; transform: none; }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;
